import styled from 'styled-components';
import { OBannerFeatureLayout, OBannerFeatureContentAlignment } from './OBannerFeature.types';
import { baseVariables } from '../../styles';

const { spacers, mediaQuery } = baseVariables;

interface WrapperProps {
  $layout: OBannerFeatureLayout;
}
interface ContentSectionProps {
  $contentAlignment?: OBannerFeatureContentAlignment;
}

interface TextBlockWrapperProps {
  $alignment?: OBannerFeatureContentAlignment;
}

interface ButtonWrapperProps {
  $contentAlignment?: OBannerFeatureContentAlignment;
}

export const Wrapper = styled.div<WrapperProps>`
  flex-direction: column-reverse;
  flex-wrap: nowrap;
  padding-block: 3rem;
  gap: ${spacers?.spacers?.[5] ?? '2rem'};

  @media ${mediaQuery.md} {
    flex-direction: ${({ $layout }) => ($layout === OBannerFeatureLayout.Reverse ? 'row-reverse' : 'row')};
    /* Top-align columns so a tall text column pins the image to the top;
       the text block itself vertically centers within its own column below. */
    align-items: flex-start;
  }

  @media ${mediaQuery.lg} {
    gap: 4rem;
  }
`;

export const ContentSection = styled.div<ContentSectionProps>`
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  justify-content: ${({ $contentAlignment }) =>
    $contentAlignment === OBannerFeatureContentAlignment.Center ? 'center' : 'flex-start'};

  @media ${mediaQuery.md} {
    /* Fill the row height (driven by the taller column). When the image is
       taller, the leftover space lets the text block center vertically; when
       the text is taller, there is no leftover space so it stays top-aligned. */
    align-self: stretch;
    justify-content: center;
  }
`;

export const TextBlockWrapper = styled.div<TextBlockWrapperProps>`
  display: flex;
  flex-direction: column;
  gap: ${spacers?.spacers?.[4] ?? '1.5rem'};
  align-items: ${({ $alignment }) => ($alignment === OBannerFeatureContentAlignment.Center ? 'center' : 'flex-start')};
`;

export const ButtonWrapper = styled.div<ButtonWrapperProps>`
  display: flex;
  gap: ${spacers?.spacers?.[3] ?? '1rem'};
  justify-content: ${({ $contentAlignment }) =>
    $contentAlignment === OBannerFeatureContentAlignment.Center ? 'center' : 'flex-start'};
`;

export const ImageSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${mediaQuery.md} {
    /* Pin the media to the top of the row when the text column is the taller one. */
    align-self: flex-start;
  }

  .feature-media {
    border-radius: var(--t-images-border-radius, 14px);
  }
`;
